import DebtorGrid from '@/features/debtor/debtorGrid';

export default function Debtor() {
 return (
    <>
      <DebtorGrid/>
    </>
  )
}
